export const useViewModel = ( isRoadsideAssistanceEnabled: boolean ) => new class
{

    roadsideAssistanceCategory =  {
        isExpanded: false, 
        items: [
            { icon: 'help-me:accident', title: "I've had an accident", path: '/my-garage/concierge/emergency/accident' },
            { icon: 'help-me:battery', title: "I have a battery problem", path: '/my-garage/concierge/emergency/flat-battery' },
            { icon: 'help-me:flat-tyre', title: "I have a flat tyre", path: '/my-garage/concierge/emergency/flat-tyre' },
            { icon: 'help-me:fuel', title: "I ran out of fuel", path: '/my-garage/concierge/emergency/fuel' },
            { icon: 'help-me:keys', title: "I'm locked out of my car", path: '/my-garage/concierge/emergency/locked-out' },
        ]
    };
        
    conciergeCategory = {
        isExpanded: false, 
        items: [
            { icon: 'help-me:service', title: "I'd like to book a service", path: undefined },
            { icon: 'help-me:scratch', title: "I need to repair bodywork", path: undefined },
            { icon: 'help-me:windscreen', title: "I have a cracked windscreen", path: undefined },
            { icon: 'alert-triangle', title: "I have an engine warning light", path: undefined },
            { icon: 'help-me:maintenance', title: "My engine sounds different", path: undefined },
        ]
    };

}